import AppHeader from "@/components/AppHeader";

export default {
  name: "master-phrase-new",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.phrase.company_id = localStorage.company_id;
  },
  data() {
    return {
      phrase: {
        company_id: "",
        template_text: ""
      },
      companies: "",
      getCompaniesEnd: false,
      savingFlag: false
    };
  },
  computed: {
    authorityCheckNotUseCompany() {
      if (
        localStorage.user_authority == 3 ||
        localStorage.user_authority == 4
      ) {
        // 総務部でログイン
        return true;
      }
      return false;
    }
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async createPhrase() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let data = this.phrase;
      let res = await this.$store
        .dispatch("CREATE_PHRASE", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_phrase" });
      }
    },
    goMasterPhrase() {
      this.$router.push({ path: "/master_phrase" });
    }
  }
};
